import './Contact.css';

import { useTranslation } from 'react-i18next';

function Contact() {

  const { t } = useTranslation();

  return (

    <section className="contact" id="contact">

      <div className="contact-container">

        <p className="section-label">
          {t('contact.label')}
        </p>

        <h2>
          {t('contact.title')}
        </h2>

        <p className="contact-description">
          {t('contact.description')}
        </p>

        <div className="contact-info">

          <p>

            <strong>{t('contact.email')}:</strong>

            {' '}

            anna@example.com

          </p>

        </div>

        <a
          href="mailto:anna@example.com"
          className="contact-button"
        >
          {t('contact.button')}
        </a>

      </div>

    </section>

  );

}

export default Contact;